import WOW from 'wow.js'

export default {
  install: () => {
    const wow = new WOW();
    wow.init();
  }
}